module.exports = __webpack_public_path__ + "static/media/logo.cd3aca95.svg";